import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  input,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { DocumentService } from '@app/shared/services';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AddTrustTemplate } from '@app/shared/component/add-trust-template-dialog/add-trust-template.interfaces';
import { CreateFromWithVaultComponent } from '@app/shared/component/create-from-with-vault/create-from-with-vault.component';
import { environment } from '@env/environment';
import { fetchAuthSession } from '@aws-amplify/auth';
import { MatMenuTrigger } from '@angular/material/menu';
import { AnimationOptions } from 'ngx-lottie';
import { ToastrService } from 'ngx-toastr';
import { AddEntityDilaogComponent } from '../../../dialogs/add-entity-dilaog/add-entity-dilaog.component';
import { AddDocumentComponent } from '../../add-document.component';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import { jsbn } from 'node-forge';
import { UntypedFormControl } from '@angular/forms';
import { ChecklistTaskService } from '@app/shared/services/checklist/checklist-task.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { vaultStoreActions } from '@app/root-store/vault-store';
import { RootStoreState } from '@app/root-store';
import { Store } from '@ngrx/store';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'non-document-linking-template',
  templateUrl: './non-document-linking-template.component.html',
  styleUrl: './non-document-linking-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NonDocumentLinkingTemplateComponent implements OnInit, OnDestroy {
  @Input() fId = 1;
  @Input() ignore_ai_suggestion = [];
  @Input() isDocumentLinking = true;
  @Input() currentFormId;
  @Input() currentuserId;
  @Input() origin;
  @Input() showButton = true;
  @Input() formName;
  @Input() data;
  @Input() hideManageButton;
  @Input() isRemoveEditSaveSharing = false;
  @Input() formsList;
  merge_forms_list = [];
  @Input() categories;
  @Output() aiRunningEvent = new EventEmitter<any>();
  @Output() vaultSelectionUpdateEvent = new EventEmitter<any>();
  @Output() aiFetchDocumentEvent = new EventEmitter<any>();
  @Output() linkedFormsUpdated = new EventEmitter<void>();
  @Output() nonDocumentlinkingTemplateSelectionChange = new EventEmitter<{
    template: any;
    index: number;
    isChecked: boolean;
  }>();
  @Output() suggestionSelectionChange = new EventEmitter<{
    suggestion: any;
    index: number;
    isChecked: boolean;
    type: 'linked' | 'new';
  }>();
  @Output() templateSuggestionSelectionChange = new EventEmitter<{
    templateSuggestion: any;
    index: number;
    isChecked: boolean;
  }>();
  @ViewChild('globalSearchIcon') globalSearchIcon: ElementRef;
  @ViewChild(MatAutocompleteTrigger) autoCompleteTrigger!: MatAutocompleteTrigger;
  suggestions_data = [];
  template_suggestion = [];
  subscription = new Subscription();
  loadingItems = [1, 2, 3];
  linkedForms = [];
  filterType = 'All Types';
  isExistingTemplatesLoading = true;
  filterTypeNew = 'All Types';
  existingTemplateSuggestions = [];
  filterTypeList = [];
  isLoading = true;
  newTemplateSuggestions = [];
  existingTemplates = [];
  isInputFocused = false;
  textBoxPlaceHolder = 'Search Existing Templates';
  textBoxPlaceHolderCreate = 'New Template Options';
  connectionUserFormControl = new UntypedFormControl();
  connectionNewUserFormControl = new UntypedFormControl();
  ai_is_loading = false;
  animation: AnimationOptions = {
    path: '/assets/lottie/animation-4.json',
  };
  isIpadOrTabletScreenWidth = signal(false);
  screenWidth: number;
  selectionState: { [key: string]: boolean } = {};

  // Worker reference for proper cleanup
  private checkStatusWorker: Worker | undefined;

  constructor(
    private documentService: DocumentService,
    private dialog: MatDialog,
    private checklistTaskService: ChecklistTaskService,
    private cd: ChangeDetectorRef,
    private store$: Store<RootStoreState.State>,
    private sharedVaultService: SharedVaultService,
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {
    if (this.isRemoveEditSaveSharing) {
      this.connectionUserFormControl.disable();
      this.connectionNewUserFormControl.disable();
    }
    this.checkStatus();
    if (this.fId !== 1) {
      this.getSuggestionsForForm();
    }
  }
  clearInput() {
    this.connectionUserFormControl.setValue('');
  }
  onInputFocusNew() {
    this.isInputFocused = true;
    this.globalSearchIcon.nativeElement.style.display = 'none';
    this.cd.detectChanges();
  }

  onInputBlurNew() {
    this.isInputFocused = false;
    this.globalSearchIcon.nativeElement.style.display = 'inline-block';
    this.cd.detectChanges();
  }
  clearInputNew() {
    this.connectionNewUserFormControl.setValue('');
  }
  onInputFocus() {
    this.isInputFocused = true;
    // this.initData();
    // if (!this.connectionUserFormControl.value) {
    //   this.isListViewOpen = false;
    // }
    this.globalSearchIcon.nativeElement.style.display = 'none';
    this.cd.detectChanges();
  }

  onInputBlur() {
    this.isInputFocused = false;
    this.globalSearchIcon.nativeElement.style.display = 'inline-block';
    this.cd.detectChanges();
  }
  deleteSuggestion(template_suggestion_item) {
    this.subscription.add(
      this.documentService
        .updateFormsUserIgnoreSuggestion({
          id: this.currentFormId,
          ignore_ai_suggestion: template_suggestion_item?.displayType || template_suggestion_item?.type,
        })
        .subscribe((res) => {
          template_suggestion_item.ignore_ai_suggestion = true;
          this.cd.detectChanges();
        })
    );
  }
  getSuggestionsForForm() {
    let currentTemplate = this.formsList.find((x) => x.id == this.fId);
    if (currentTemplate) {
      let all_links = currentTemplate.all_links;
      let split_links = this.splitAllItemsData(all_links);
      let newTemplateList = [];

      split_links.forEach((templateSuggestion) => {
        try {
          if (templateSuggestion?.template?.length) {
            let template_list_arr = [];
            templateSuggestion.template.forEach((element) => {
              const result = element.split(',').map((item) => item.trim());
              template_list_arr = template_list_arr.concat(result);
            });
            template_list_arr = template_list_arr.map((x) => x.trim());

            template_list_arr.forEach((element, index) => {
              if (element.includes('#')) {
                let parts: string[] = element.split('#');
                newTemplateList.push({
                  templateType: parts[0],
                  templateSubType: parts[1],
                });
              } else {
                newTemplateList.push({
                  templateType: element,
                });
              }
            });
          }
        } catch (error) {}
      });
      this.template_suggestion = [];
      newTemplateList.forEach((element) => {
        let findTemplateType = this.formsList.find((item) => item.type == element.templateType);
        let ignore_ai_suggestion = false;
        if (
          this.ignore_ai_suggestion.includes(element.templateType) ||
          (element?.templateSubType && this.ignore_ai_suggestion.includes(element.templateSubType))
        ) {
          ignore_ai_suggestion = true;
        }
        if (findTemplateType) {
          this.template_suggestion.push({
            ...findTemplateType,
            displayType: element.templateSubType,
            isGroup: false,
            img: findTemplateType.image,
            ignore_ai_suggestion: ignore_ai_suggestion,
            label: 'Create New ' + findTemplateType.type,
            isCustomImg: true,
          });
        }
      });
      this.cd.detectChanges();
    }
  }
  splitAllItemsData(input: string) {
    const pattern = /<([^>]+)>\s*([^|]*)/g; // Regex to match <key> value pairs
    const matches: { name: string; template: string[] }[] = [];

    let match;
    while ((match = pattern.exec(input)) !== null) {
      matches.push({
        name: match[1].trim(),
        template: match[2]
          .trim()
          .split('|')
          .map((item) => item.trim()),
      });
    }

    return matches;
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();

    // Terminate worker
    if (this.checkStatusWorker) {
      this.checkStatusWorker.terminate();
      this.checkStatusWorker = undefined;
    }
  }
  aiLoading() {
    this.ai_is_loading = true;
    this.cd.detectChanges();
    this.checkStatus();
  }
  async checkStatus(isLoading = true) {
    this.isLoading = isLoading;
    if (this.isLoading) {
      this.linkedForms = [];
      this.suggestions_data = [];
    }
    this.cd.detectChanges();

    // Terminate previous worker if exists
    if (this.checkStatusWorker) {
      this.checkStatusWorker.terminate();
    }

    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        this.checkStatusWorker = new Worker(new URL('./non-document-linking-template.worker', import.meta.url), { type: 'module' });

        const data = {
          token: '',
          url: `${environment.apiUrl}/api/vault/check-upload-file-ai-running`,
          vault_user_form_id: this.currentFormId,
          execution_type: 'non_document_linking',
        };
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        this.checkStatusWorker.onmessage = async ({ data }) => {
          if (data.data.ai_is_running) {
            this.ai_is_loading = true;
            setTimeout(() => {
              this.checkStatus();
            }, 15000);
          } else {
            this.ai_is_loading = false;
            this.getSuggestions();
            this.getLinkedForms();
          }
          resolve(data);
        };
        this.checkStatusWorker.postMessage(data);
      } else {
        this.isLoading = false;
        resolve(null);
      }
    });
  }
  deleteFileFunction(template) {
    this.subscription.add(
      this.documentService.deleteUserMultipleFormAssociation(this.currentuserId, [template.id], this.currentFormId).subscribe((result) => {
        this.getLinkedForms();
      })
    );
  }
  linkTemplateExistingForm(item) {
    try {
      this.autoCompleteTrigger.closePanel();
    } catch (error) {}
    item.suggested_vault_user_form_id = item.id;
    this.assccitareform(item);
  }
  linkTemplate(template) {
    if (template.suggested_vault_user_form_id) {
      this.assccitareform(template);
    } else {
      this.createFile(template, false);
    }
  }
  createFile(file, is_ai_suggestion = false) {
    try {
      this.autoCompleteTrigger.closePanel();
    } catch (error) {}
    if (file?.organization_section?.includes('Entities')) {
      const dialogRef = this.dialog.open(AddEntityDilaogComponent, {
        panelClass: 'full-window-dialog',
        autoFocus: false,
        data: { entityType: file.suggested_vault_form_id, entityName: file.new_form_name },
      });
      this.subscription.add(
        dialogRef.afterClosed().subscribe((res) => {
          if (res?.status === 'success') {
            file.suggested_vault_user_form_id = res.id ? res.id : res.data.id;
            this.toastr.success(`${file.type} has been created successfully`);

            this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.currentuserId, false));
            this.vaultSelectionUpdateEvent.emit({
              action: 'update_vault_selection',
            });
            this.assccitareform(file);
            if (is_ai_suggestion) {
              const type = file.displayType ? file.displayType : file.type;
              this.setIgnoreAiSuggestion(type);
            }
          }
        })
      );
    } else {
      const dialogRef = this.dialog.open<CreateFromWithVaultComponent, AddTrustTemplate>(CreateFromWithVaultComponent, {
        data: {
          inbox_attachment_id: undefined,
          vault_id: undefined,
          vaultFormId: this.isDocumentLinking ? file.suggested_vault_form_id : file.id,
          title: this.formsList.find((x) => x.id == (this.isDocumentLinking ? file.suggested_vault_form_id : file.id))?.type,
          vaultType: undefined,
          organization_section: file.organization_section,
          form_name_updated_by_user: false,
          hub_vault_user_form_id: undefined,
          displayType: file.displayType,
          isDocumentLinking: this.isDocumentLinking,
          origin: undefined,
          suggestion_new_form_name: file?.new_form_name,
        },
      });
      this.subscription.add(
        dialogRef.afterClosed().subscribe(
          (res) => {
            if (res?.status) {
              this.toastr.success(`${file.type} has been created successfully`);
              file.suggested_vault_user_form_id = res.id ? res.id : res.data.id;

              this.assccitareform(file);
              if (is_ai_suggestion) {
                const type = file.displayType ? file.displayType : file.type;
                this.setIgnoreAiSuggestion(type);
              }
            }
          },
          (error) => {}
        )
      );
    }
  }
  setIgnoreAiSuggestion(type) {
    this.ignore_ai_suggestion.push(type);
    this.subscription.add(
      this.documentService
        .updateFormSuggestion({
          id: this.currentFormId,
          ignore_ai_suggestion: type,
        })
        .subscribe(
          (res) => {
            this.ngOnInit();
          },
          (error) => {}
        )
    );
  }
  refetchDocument() {
    this.subscription.add(
      this.sharedVaultService
        .refreshDocument({
          vault_user_form_id: this.currentFormId,
          user_id: this.currentuserId,
          execution_type: 'template_summary_2',
        })
        .subscribe((res) => {
          this.checkStatus();
        })
    );
  }
  assccitareform(template) {
    let payload = {
      user_id: this.currentuserId,
      vault_user_form_id: [template.suggested_vault_user_form_id],
      created_by_user_id: this.currentuserId,
      association_type: 'Documents',
      associate_vault_user_form_id: template.vault_user_form_id ? template.vault_user_form_id : this.currentFormId,
    };
    this.subscription.add(
      this.documentService.createUserFormAssociationMultiple(payload).subscribe(
        (res) => {
          const id = template.ai_suggestion_id ? template.ai_suggestion_id : template.id;
          this.subscription.add(
            this.documentService.updateDeactvateSuggestion(id).subscribe((res) => {
              this.checkStatus(false);
              this.getSuggestionsForForm();
            })
          );
        },
        (error) => {}
      )
    );
  }
  removeDocumentSuggestionTag(template) {
    this.subscription.add(
      this.documentService.updateDeactvateSuggestion(template.id).subscribe((res) => {
        this.getSuggestions(false);
      })
    );
  }

  getSuggestions(isLoading = true) {
    this.isLoading = isLoading;
    this.subscription.add(
      this.documentService
        .getFormLinkingSuggestions(this.currentFormId, this.isDocumentLinking ? 'linking' : 'non_document_linking')
        .subscribe((res) => {
          if (res && res?.length > 0) {
            this.suggestions_data = res;
          } else {
            this.suggestions_data = [];
          }
          if (this.isDocumentLinking) {
            this.newTemplateSuggestions = res
              .filter((x) => x.suggested_vault_form_id)
              .map((x) => ({
                ...x,
                ai_suggestion: true,
              }));
          }

          this.existingTemplateSuggestions = res
            .filter((x) => x.suggested_vault_user_form_id)
            .map((x) => ({
              ...x,
              ai_suggestion: true,
            }));
          this.isLoading = false;
          this.formsList = this.formsList.map((x) => ({
            ...x,
            ai_suggestion: false,
            ai_suggestion_id: null,
          }));
          this.filterTypeList = ['All Types', ...new Set(this.categories.map((x) => x.name))];
          this.filterTypeList = this.filterTypeList.filter((x) => x !== 'Documents');
          this.getFormExistingTemplates();
          this.newTemplateSuggestions = this.template_suggestion.map((x) => ({
            ...x,
            suggested_vault_form_id: x.id,
            ai_suggestion: true,
          }));
          this.cd.detectChanges();
        })
    );
  }
  getFormExistingTemplates() {
    this.subscription.add(
      this.checklistTaskService.getAllForms(this.currentuserId).subscribe((res) => {
        this.existingTemplates = res.data.map((x) => ({
          ...x,
          ai_suggestion: false,
          ai_suggestion_id: null,
        }));
        this.isExistingTemplatesLoading = false;
        this.mergeTemplates();
        this.cd.detectChanges();
      })
    );
  }

  mergeTemplates() {
    this.existingTemplates.forEach((x) => {
      if (this.existingTemplateSuggestions.findIndex((z) => z.suggested_vault_user_form_id == x.id) >= 0) {
        x.ai_suggestion = true;
        x.ai_suggestion_id = this.existingTemplateSuggestions.find((z) => z.suggested_vault_user_form_id == x.id).id;
      }
    });
    this.existingTemplates = this.existingTemplates.sort((a, b) => {
      if (a.ai_suggestion) {
        return -1;
      }
      return 1;
    });
    this.merge_forms_list = this.newTemplateSuggestions;
    this.formsList.forEach((x) => {
      if (this.newTemplateSuggestions.findIndex((z) => z.suggested_vault_form_id == x.id) == -1) {
        this.merge_forms_list.push({
          ...x,
          ai_suggestion: false,
          ignore_ai_suggestion: false,
        });
      }
    });
    this.cd.detectChanges();
  }

  openSuggestionTemplate(file) {
    let data = file;
    data.id = file.suggested_vault_user_form_id;
    const dialogOpen = this.dialog.open(AddDocumentComponent, {
      disableClose: true,
      data: {
        file: data,
        mode: 'edit',
        isintelligent: false,
        isfileListLoad: true,
        isFromChecklist: true,
        vufid: file.suggested_vault_user_form_id,
        vault_user_form_user_id: this.currentuserId,
        isReport: true,
      },
      panelClass: 'full-window-dialog-add-document',
      autoFocus: false,
    });
    this.subscription.add(
      dialogOpen.afterClosed().subscribe((res) => {
        this.ngOnInit();
      })
    );
  }
  openManageTemplate(file) {
    const dialogOpen = this.dialog.open(AddDocumentComponent, {
      disableClose: true,
      data: {
        file,
        mode: 'edit',
        isintelligent: false,
        isfileListLoad: true,
        isFromChecklist: true,
        vufid: file.vault_user_form_id,
        vault_user_form_user_id: file.userid,
        isReport: true,
      },
      panelClass: 'full-window-dialog-add-document',
      autoFocus: false,
    });
    this.subscription.add(
      dialogOpen.afterClosed().subscribe((res) => {
        this.ngOnInit();
      })
    );
  }
  getLinkedForms() {
    if (this.isDocumentLinking) {
      const body = {
        user_id: this.currentuserId,
        vault_user_form_id: this.currentFormId,
        type: 'documents',
      };
      this.subscription.add(
        this.documentService.getFormsLinkedDocuments(body).subscribe((res) => {
          if (res.length) {
            res = res.map((x) => {
              return {
                ...x,
                type_template: x.type_template.replace(/,\s*/g, ', '),
              };
            });
            this.linkedForms = res;
          } else {
            this.linkedForms = [];
          }

          this.isLoading = false;
          this.cd.detectChanges();
          this.linkedFormsUpdated.emit();
        })
      );
    } else {
      const body = {
        user_id: this.currentuserId,
        vault_user_form_id: this.currentFormId,
      };

      this.subscription.add(
        this.documentService.getFormsLinked(body).subscribe((res) => {
          if (res.data.length) {
            this.linkedForms = res.data;
          } else {
            this.linkedForms = [];
          }
          this.isLoading = false;
          this.cd.detectChanges();
          this.linkedFormsUpdated.emit();
        })
      );
    }
  }

  onNonDocumentLinkingTemplateSelectionChange(template: any, index: number, isChecked: boolean) {
    const key = `linked_template_${index}`;
    this.selectionState[key] = isChecked;
    this.nonDocumentlinkingTemplateSelectionChange.emit({ template, index, isChecked });
    this.cd.detectChanges();
  }

  onSuggestionSelectionChange(suggestion: any, index: number, isChecked: boolean, type: 'linked' | 'new') {
    const key = `suggestion_${type}_${index}`;
    this.selectionState[key] = isChecked;
    this.suggestionSelectionChange.emit({ suggestion, index, isChecked, type });
    this.cd.detectChanges();
  }

  onTemplateSuggestionSelectionChange(templateSuggestion: any, index: number, isChecked: boolean) {
    const key = `template_suggestion_${index}`;
    this.selectionState[key] = isChecked;
    this.templateSuggestionSelectionChange.emit({ templateSuggestion, index, isChecked });
    this.cd.detectChanges();
  }

  clearSelections() {
    this.selectionState = {};
    this.cd.detectChanges();
  }
}
